define('responsive-gameday/views/Monitor/StateMonitor',['require','exports','module','GameDayCore','GameDayCore/GDModel/enums/events/EventTypes','GameDayCore/GDModel/enums/datasources/Datasources','./Events/SceneStateEvents','message-service/message-service','gameday-index-enums/enums/baseball/GameStates','GameDayCore/GDModel/enums/baseball/PlayerTypes','GameDayCore/GDUtil/dataMapping/GameStateUtil','responsive-gameday-tracking/responsive-gameday-tracking','extant/extant','../../utils/ui-log','moment','jquery','./ViewModels/PlaysViewModel','./ViewModels/BoxscoreViewModel','./ViewModels/InningsViewModel','./ViewModels/VideoViewModel','./ViewModels/GamecenterViewModel','./ViewModels/ScoringPlaysViewModel','./ViewModels/InningPlaysViewModel'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        CoreEventTypes = require("GameDayCore/GDModel/enums/events/EventTypes"),
        CoreDatasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        SceneStateEvents = require("./Events/SceneStateEvents"),
        MessageService = require("message-service/message-service"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        PlayerTypes = require("GameDayCore/GDModel/enums/baseball/PlayerTypes"),
        GameStateUtil = require( 'GameDayCore/GDUtil/dataMapping/GameStateUtil' ),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        exists = require("extant/extant"),
        uilog = require("../../utils/ui-log"),
        moment = require("moment"),
        $ = require("jquery"),

        // mr. managers
        PlaysViewModel = require("./ViewModels/PlaysViewModel"),
        BoxViewModel = require("./ViewModels/BoxscoreViewModel"),
        InningsViewModel = require("./ViewModels/InningsViewModel"),
        VideoViewModel = require("./ViewModels/VideoViewModel"),
        GamecenterViewModel = require("./ViewModels/GamecenterViewModel"),
        ScoringPlaysViewModel = require( "./ViewModels/ScoringPlaysViewModel" ),
        InningPlaysViewModel = require( "./ViewModels/InningPlaysViewModel" );

        // mr. managers

    var playManager,
        boxscoreManager,
        inningsManager,
        scoringManager,
        inningPlaysManager,
        videoManager,
        gamecenterManager;

        // private vars for tracking stuffs
    var game = null,
        newStateEvents,
        updateCnt = 0,
        statesHash = {};

    // ------------------------- public functions ------------------------- //
    /**
     * Function init
     *
     * activation of the state monitor (after data is loaded)
     */
    exports.init = function () {
        //  These need to be built in the init for now to avoid event conflicts with DataDistributor
        playManager = new PlaysViewModel();
        boxscoreManager = new BoxViewModel();
        inningsManager = new InningsViewModel();
        scoringManager = new ScoringPlaysViewModel();
        inningPlaysManager = new InningPlaysViewModel();
        videoManager = new VideoViewModel();
        gamecenterManager = new GamecenterViewModel();
        // If loading a game that's already started, set a few things from the get go
        game = $.extend({}, GDC.getGameData());
        processUpdates();

        MessageService.addListener(CoreEventTypes.UPDATE, processUpdates);
        MessageService.addListener(CoreEventTypes.INIT_DATA_LOADED, processUpdates);
		MessageService.addListener(CoreEventTypes.BEGIN_COMMERCIAL_BREAK, enterCommercialBreak);
		MessageService.addListener(CoreEventTypes.END_COMMERCIAL_BREAK, exitCommercialBreak);
    };

    /**
     * Function enterCommercialBreak
     *
     * sets the state in the hash tracker and dispatches an event
     */
    function enterCommercialBreak() {
		newStateEvents = { };
		updateCnt = 0;

		addToUpdates(SceneStateEvents.COMMERCIAL_BREAK_BEGIN);
		statesHash.inCommercialBreak = true;

		MessageService.publish(SceneStateEvents.SCENE_STATE_UPDATE, newStateEvents);
    };

    /**
     * Function exitCommercialBreak
     *
     * sets the state in the hash tracker and dispatches an event
     */
    function exitCommercialBreak() {
		newStateEvents = { };
		updateCnt = 0;

		addToUpdates(SceneStateEvents.COMMERCIAL_BREAK_END);
		statesHash.inCommercialBreak = false;

		MessageService.publish(SceneStateEvents.SCENE_STATE_UPDATE, newStateEvents);
    };

    // ------------------------- private functions ------------------------- //
    function processUpdates() {
        game = $.extend({}, GDC.getGameData());

        var linescore = game.linescore;
        // Set title of page to game you're viewing
        document.title = linescore.away_name_abbrev + " vs. " + linescore.home_name_abbrev + " - " + moment(linescore.time_date).format("MM/DD/YYYY");

        if(game){
            determineGameState();
        }
    }


    function determineGameState() {
        newStateEvents = { };
        updateCnt = 0;

        try {
            checkGame();
            checkGameStateChange(); // Check gamestate before checking anything else, this sets proper hash arg

            // These checks are only appropirate for Live game state
            if(game.linescore.abstractGameState === GameStates.ABSTRACT_LIVE) {
                checkMidInning();
                checkCountChange();
                checkBatterSwitchedStance();
                checkNewBatter();
                checkNewBatterWithPitches();
                checkSubstitutions();
                checkHitsChange();
                checkMenOnBaseChange();
                checkCoachVisitEvent();
                checkVideoCount();   
            }
        } catch (err) {
            uilog.error("Unable to determine detailed game state due to err: ",err);
        }

        setCheckSellByDates();
        setViewGameState();
    }

    function setCheckSellByDates() {
        if (!exists(statesHash, "timestamps")) {
            statesHash.timestamps = [
                {
                    name        : CoreDatasources.LINESCORE,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.PLAYS,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.BOXSCORE,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.INNING,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.ALL_INNINGS,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.SCORING_PLAYS,
                    timestamp   : 0
                },{
                    name        : CoreDatasources.VIDEO,
                    timestamp   : 0
                }
            ];
        }
        var i = 0,
            datasource,
            timestamps = statesHash.timestamps,
            len = timestamps.length;

        for (; i < len; i++) {
            datasource = timestamps[i];
            uilog.info('distribute to view models',datasource.name,game);
            if (exists(game[datasource.name])){
                if (game[datasource.name].timestamp > datasource.timestamp) {
                    distributeToViewModels(datasource.name);
                    datasource.timestamp = game[datasource.name].timestamp;
                }
            }
        }
    }

    function distributeToViewModels(datasrc) {
        var viewModel = getViewModelForDatasource(datasrc);
        viewModel.refresh(game, datasrc, newStateEvents);
    }

    function getViewModelForDatasource(datasrc){
        var viewModel;
        switch (datasrc) {
            case CoreDatasources.PLAYS:
            case CoreDatasources.HOT_COLD_ZONE:
                viewModel = playManager;
                break;
            case CoreDatasources.BOXSCORE:
                viewModel = boxscoreManager;
                break;
            case CoreDatasources.INNING:
                viewModel = inningsManager;
                break;
            case CoreDatasources.ALL_INNINGS:
                viewModel = inningPlaysManager;
                break;
            case CoreDatasources.SCORING_PLAYS:
                viewModel = scoringManager;
                break;
            case CoreDatasources.VIDEO:
                viewModel = videoManager;
                break;

            case CoreDatasources.LINESCORE: // Not sure about this
                viewModel = gamecenterManager;
                break;
        }
        return viewModel;
    }

    /**
     * Adds an enum to an array, which will get sent via an
     * event so that subscribers know what changed since the last
     * update.
     */
    function addToUpdates($evt, $value) {
        updateCnt++;
        newStateEvents[$evt] = $value || true;
    }

    function checkMidInning() {
        // Game hasn't started or is over, stop advertising
        if(game.linescore.abstractGameState === GameStates.ABSTRACT_FINAL
            || game.linescore.abstractGameState === GameStates.ABSTRACT_PREGAME) {
            return;
        }

        // check to see if an inning has just ended...
        if (threeOuts() && midInningIsNew() && !gameIsOver()) {
            checkIfGameWentIntoExtraInnings();

            statesHash.lastHalfInning = game.play.half_inning + game.play.inning.toString();
            addToUpdates(SceneStateEvents.MID_INNING);
        }

        // check to see if a new half inning has just begun...
        if (exists(game, "play.atbat") && statesHash.lastOffensiveTeam !== game.play.offense.id) {
            addToUpdates(SceneStateEvents.NEW_HALF_INNING);
            statesHash.lastOffensiveTeam = game.play.offense.id;
        }
    }

    /**
     * Checks if the game is in the bottom of the ninth and the score is tied.
     * This is triggered by checkMidInning, so three outs is implicit.
     * This doesn't add anything to the scene state Enums, it's just a
     * convenient play to put the sniffer logic.
     * @see checkMidInning
     */
    function checkIfGameWentIntoExtraInnings() {
        if (game.play.half_inning === "bottom" && Number(game.play.inning) === 9 && gameIsTied()) {
            addToUpdates(SceneStateEvents.GAME_STATE_CHANGE_TO_EXTRA_INNINGS);
        }
    }

    /**
     * Checks to see if substitutions have been made
     */
    function checkSubstitutions() {
        var lineupObj,
            subs;

        if (game.play.defense.type == "home") {
            lineupObj = statesHash.homeDefenseLineup || { };
        } else {
            lineupObj = statesHash.awayDefenseLineup || { };
        }

        if (!exists(lineupObj, "p")) {
            var positions = [].concat(PlayerTypes.POS_ARRAY),
                position,
                team = game.play.defense;
            // this may not be explicit enough,
            // but i happen to know "p" is item 0 in the array and we want to skip that...
            for (var i = 1; i < positions.length; i++) {
                position=positions[i];
                if(position in team){
                    lineupObj[positions[i]] = team[positions[i]].pid;
                }
            }
            return;
        }

        subs = [];

        for (var j = 0; j < positions.length; j++) {

            if (lineupObj[positions[j]] != game.play.defense[positions[j]].pid) {
                if (positions[j] == "p") {
                    //pitcher substitution
                    lineupObj[positions[j]] = game.play.defense[positions[j]].pid;
                    statesHash.lastPitcherChangeHadCount = true;

                    statesHash.pitchSub = true;
                    addToUpdates(SceneStateEvents.PITCHER_CHANGE);
                } else {
                    //non-pitcher substitution
                    subs.push({
                        pos: positions[j],
                        newpid: game.play.defense[positions[j]].pid,
                        oldpid: lineupObj[positions[j]]
                    });

                    lineupObj[positions[j]] = game.play.defense[positions[j]].pid;
                }
            }
        }

        if (subs.length > 0) {
            addToUpdates(SceneStateEvents.DEFENSIVE_SUBSTITUTION, subs);
        }


    }

    function checkCoachVisitEvent() {
        if (game.play.event == "pitching_substitution") {
            statesHash.pitchSub = true;
            addToUpdates(SceneStateEvents.PITCHER_CHANGE);
        }
    }

    /**
     * If the count has changed at all, add the appropriate
     * count enum to the update.
     */
    function checkCountChange() {
        var countEnum = SceneStateEvents["COUNT_" + game.play.balls.toString() + "_" + game.play.strikes.toString()];

        if (statesHash.lastCount == countEnum) { return; }

        addToUpdates(SceneStateEvents.COUNT_CHANGE);
        addToUpdates(countEnum);

        if (statesHash.pitchSub === true) {
            statesHash.pitchSub = false;
            addToUpdates(SceneStateEvents.PITCHER_CHANGE_COMPLETE);
        }

        statesHash.lastCount = countEnum;

    }

    /**
     * check for changes to men on base, and add the appropriate
     * situational enum if the MOB data has changed.
     *
     * Also check to see if the runners in scoring position status
     * has changed. If the condition has changed, add that to the
     * enum array.
     */
    function checkMenOnBaseChange() {
        var b1 = (exists(game, "play.offense.first")) ? "1" : "";
        var b2 = (exists(game, "play.offense.second")) ? "2" : "";
        var b3 = (exists(game, "play.offense.third")) ? "3" : "";
        var sceneEnum;

        switch (b1 + b2 + b3) {
            case "":
                sceneEnum = SceneStateEvents.BASES_EMPTY;
                break;
            case "1":
                sceneEnum = SceneStateEvents.RUNNER_ON_FIRST;
                break;
            case "2":
                sceneEnum = SceneStateEvents.RUNNER_ON_SECOND;
                break;
            case "3":
                sceneEnum = SceneStateEvents.RUNNER_ON_THIRD;
                break;
            case "12":
                sceneEnum = SceneStateEvents.RUNNERS_ON_FIRST_AND_SECOND;
                break;
            case "13":
                sceneEnum = SceneStateEvents.RUNNERS_ON_FIRST_AND_THIRD;
                break;
            case "23":
                sceneEnum = SceneStateEvents.RUNNERS_ON_SECOND_AND_THIRD;
                break;
            case "123":
                sceneEnum = SceneStateEvents.BASES_LOADED;
                break;
            default:
                sceneEnum = SceneStateEvents.BASES_EMPTY;
                break;
        }

        if (statesHash.lastMenOnBase == sceneEnum)
            return;
        statesHash.lastMenOnBase = sceneEnum;
        addToUpdates(sceneEnum);

        //also check for runners in scoring position
        if (sceneEnum != SceneStateEvents.BASES_EMPTY && sceneEnum != SceneStateEvents.RUNNER_ON_FIRST) {
            //if RISP is a new condition, add the sceneEnum to the update
            if (!statesHash.lastMobHadRISP) {
                addToUpdates(SceneStateEvents.RUNNERS_IN_SCORING_POSITION);
                statesHash.lastMobHadRISP = true;
            }
        } else {
            statesHash.lastMobHadRISP = false;
        }

    }

    /**
     * Checks if a new batter has come to the plate. Will report two
     * state changes if this is the case... it will always report the
     * NEW_BATTER state, and will also report the state plus handedness.
     */
    function checkNewBatter() {
        var batter = game.play.batter.pid;
        if (statesHash.lastBatterId != null && statesHash.lastBatterId == batter){
            return;
        }

        //only track a new batter if the game isn't over
        if (game.play.liveState != GameStates.RE_WRAPUP) {
            if (statesHash.firstRun) {
                statesHash.firstRun = false;
            }
        }

        // Not the first batter
        if(statesHash.lastBatterId){
            Tracking.track_new_batter_event();
        }

        statesHash.lastBatterId = batter;

        addToUpdates(SceneStateEvents.NEW_BATTER);

        if (getBatterSide() != "left") {
            addToUpdates(SceneStateEvents.NEW_LEFT_HANDED_BATTER);
        } else {
            addToUpdates(SceneStateEvents.NEW_RIGHT_HANDED_BATTER);
        }
    }

    /**
     * Checks for a player changing his batting side
     */
    function checkBatterSwitchedStance() {
        if (!exists(game, "play.batter")) { return; }
        //don't update the current batter var here, the new batter check will do it and track that state
        var batter = game.play.batter.pid,
            currentStance =  getBatterSide();

        //if it's the same batter but the stance has changed
        if (statesHash.lastBatterId == batter && statesHash.lastBattingStance != currentStance && statesHash.lastBattingStance != null) {
            if (currentStance == "left") {
                addToUpdates(SceneStateEvents.BATTER_SWITCHED_TO_RIGHT_HANDED);
            } else if (currentStance == "right") {
                addToUpdates(SceneStateEvents.BATTER_SWITCHED_TO_LEFT_HANDED);
            }
        }

        //store the last batting stance
        statesHash.lastBattingStance == currentStance;
    }

    /**
     * Checks to see if there is a new batter who has pitches. Broke this out into its own
     * function to allow it to function independently of the checkNewBatter function.
     * The logic checking for a new batter was causing this detection to behave
     * inconsistently.
     */
    function checkNewBatterWithPitches() {
        var batter = game.play.batter.pid,
            currentStance = getBatterSide();

        if (exists(game, "play.pitcher.pitches") && (Number(game.play.pitcher.pitches) > 0) && (statesHash.lastPitcherChangeHadCount)) {
            statesHash.lastPitcherChangeHadCount = false;
        } else if ((exists(statesHash.lastBatterIDwithPitches) && statesHash.lastBatterIDwithPitches == batter) || countIsEmpty()) {
            return;
        }
        statesHash.lastBatterIDwithPitches = batter;

        addToUpdates(SceneStateEvents.NEW_BATTER);

        if (getBatterSide() != "left") {
            addToUpdates(SceneStateEvents.NEW_LEFT_HANDED_BATTER_WITH_PITCHES);
        } else if (currentStance == "right") {
            addToUpdates(SceneStateEvents.NEW_RIGHT_HANDED_BATTER_WITH_PITCHES);
        }
    }

    function countIsEmpty() {
        return currentAtBatHasNoPitchesYet();
    }

    function currentAtBatHasNoPitchesYet() {
        if (exists(game, "play.atbat")) {
            return (game.play.atbat.numPitches == 0);
        }
        return true;
    }

    function getBatterSide() {
        if (!exists(game, "play.atbat.batter")) { return "n/a"; }
        return (game.play.atbat.stand == "L") ? "right" : "left";
    }

    function checkHitsChange() {
        if (exists(game, "play.atbat") && statesHash.lastPitch != game.play.atbat.pitches.length) {
            var pitch = game.play.atbat.pitches[game.play.atbat.pitches.length - 1],
                currentStance = getBatterSide();

            statesHash.lastPitch = game.play.atbat.pitches.length;

            if (statesHash.lastPitch > 0 && pitch.type == "X" && exists(game, "play.atbat.stand")) {
                if (currentStance == "L") {
                    addToUpdates(SceneStateEvents.NEW_LEFT_HANDED_HIT);
                } else if (currentStance == "R") {
                    addToUpdates(SceneStateEvents.NEW_RIGHT_HANDED_HIT);
                }
            }
        }
    }

    /**
     * Ensure we're looking at the same game as the last update
     * If not, reset the hash, and start over;
     */
    function checkGame(){
        var currentGame = game.linescore && game.linescore.game_pk || null;
        if(currentGame && statesHash.game_pk && currentGame!==statesHash.game_pk){
            statesHash={};
        }
        statesHash.game_pk = currentGame;
    }

    /**
     * Checks for changes to the granular gamestate
     */
    function checkGameStateChange() {
        var gameState = game.play && game.play.gamestate || game.linescore.status,
            gamestate,
            UIGamestate,
            UIGamestateUpdate;
        switch (gameState) {
            case GameStates.IN_PROGRESS :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_IN_PROGRESS;
                break;
            case GameStates.WARMUP :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_WARMUP;
                break;
            case GameStates.PREVIEW :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_PREVIEW;
                break;
            case GameStates.PREGAME :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_PREGAME;
                break;
            case GameStates.LINEUPS :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_LINEUPS;
                break;
            case GameStates.DELAYED :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_DELAYED;
                break;
            case GameStates.DELAYED_START :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_DELAYED_START;
                break;
            case GameStates.FINAL :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_FINAL;
                break;
            case GameStates.GAME_OVER :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_GAME_OVER;
                break;
            case GameStates.COMPLETED_EARLY :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_COMPLETED_EARLY;
                break;
            case GameStates.SUSPENDED :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_SUSPENDED;
                break;
            case GameStates.CANCELLED :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_CANCELLED;
                break;
            case GameStates.POSTPONED :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_POSTPONED;
                break;
            case GameStates.FORFEIT :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_FORFEIT;
                break;
            case GameStates.REPLAY :
                gamestate = SceneStateEvents.GAME_STATE_CHANGE_TO_INSTANT_REPLAY;
                break;
        }

        addToUpdates(gamestate);

    }

    function setViewGameState(){
        var data = game,
            linescore = data.linescore,
            plays     = data.play,
            rawgamestate = plays && plays.status_ind || linescore.ind,
            gamestate = GameStateUtil.getUsableGameState(rawgamestate,true);

        GameStateUtil.setGameState(gamestate);

    }
    function checkVideoCount() {
        if (!exists(game, "video.videosArray")) {
            return 0;
        }

        var vids = game.video.videosArray.length;
        if (vids > statesHash.videos) {
            var diff = (vids - statesHash.videos);
            statesHash.videos = vids;
            addToUpdates(SceneStateEvents.NEW_VIDEO_HIGHLIGHTS, diff);
        }
    }

    /**
     * Boolean getter checks if this time around there's a new half-inning
     */
    function midInningIsNew() {
        return (statesHash.lastHalfInning != game.play.half_inning + game.play.inning.toString());
    }

    /**
     * Boolean getter checks if there are currently three out
     */
    function threeOuts() {
        return (game.play && game.play.outs == 3);
    }

    /**
     * Checks if the game is over (even if it hasn't gone to Game Over yet)
     */
    function gameIsOver() {
        if (game.play.liveState == GameStates.RE_WRAPUP) {
            return true;
        } else if (game.play.liveState == GameStates.RE_PITCH) {
            //home team is winning after away teams last out, or they walk off
            if (threeOuts() && isNinthInningOrLater() && homeTeamIsWinning()) {
                return true;
                //away team is winning after home teams last out
            } else if (threeOuts() && isNinthInningOrLater() && isBottomOfInning() && awayTeamIsWinning()) {
                return true;
            }
        }
        return false;
    }

    /**
     * Boolean getter checks if the home team has more runs
     */
    function homeTeamIsWinning() {
        return (game.boxscore.home_runs > game.boxscore.away_runs);
    }

	function awayTeamIsWinning() {
		return (game.boxscore.home_runs < game.boxscore.away_runs);
	}

    /**
     * Boolean getter checks if the away team has more runs
     */
    function gameIsTied() {
        return (game.boxscore.home_runs === game.boxscore.away_runs);
    }

    /**
     * Boolean getter checks if it's the bottom of the current inning
     */
    function isBottomOfInning() {
        return (game.play.half_inning == "bottom");
    }

    /**
     * Boolean getter checks if inning is 9 or greater
     */
    function isNinthInningOrLater() {
        return (Number(game.play.inning) >= 9);
    }
});

